module.exports = __webpack_public_path__ + "static/media/a1a3432c-5641-413a-b30f-256b49a362c9.5d017c61.png";